import React from "react";
import { Card, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CardMenu = (props) => {
  const { active, title, icon, children, badge } = props;

  return (
    <>
      <div className="position-relative">
        <Card border={active ? "primary" : "default"}>
          <Card.Header>
            <FontAwesomeIcon
              icon={icon}
              color={active ? "#0d6efd" : "#6c757d"}
            />
            <span className={active ? "ms-2" : "ms-2 text-muted"}>{title}</span>
          </Card.Header>
          <Card.Body>{children}</Card.Body>
        </Card>
        <Badge
          bg={active ? "primary" : "secondary"}
          pill
          className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"
        >
          <span style={{ fontSize: "1em" }}>{badge}</span>
        </Badge>
      </div>
    </>
  );
};

export default CardMenu;
